import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import Confetti from "react-confetti"; // npm i react-confetti

const SuccessSwal = ({
  open,
  icon,
  title,
  description,
  buttonText = "Continue",
  onConfirm,
  onClose,
}) => {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      {/* Confetti effect */}
      <Confetti width={window.innerWidth} height={window.innerHeight} />

      <div className="relative w-full max-w-md mx-4 rounded-2xl bg-white p-6 text-center shadow-xl animate-scaleIn">
        {/* Top handle */}
        <div className="mx-auto mb-4 h-1.5 w-12 rounded-full bg-gray-300" />

        {/* Icon */}
        <div className="relative mx-auto mb-5 flex h-28 w-28 items-center justify-center rounded-full bg-orange-50">
          {icon}
        </div>

        {/* Title */}
        <h2 className="mb-2 text-lg font-semibold text-orange-500">{title}</h2>

        {/* Description */}
        {description && (
          <p className="mb-6 text-sm text-gray-500">{description}</p>
        )}

        {/* Button */}
        <button
          onClick={onConfirm || onClose}
          className="w-full rounded-full bg-orange-500 py-3 text-sm font-medium text-white transition hover:bg-orange-600"
        >
          {buttonText}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default SuccessSwal;
